import { jsonMember, jsonObject } from 'typedjson';
import { Id } from '@shared/types/id';
import { dateSerializer } from '@api/common/json/date-serializer';
import { YYYY_MM_DD_HH_MM_SS } from '@core/locale/consts/date-format';

@jsonObject
export class SequenceCreateRequest {
  @jsonMember name!: string;
  @jsonMember({ name: 'comment' }) description!: string;
  @jsonMember({ serializer: dateSerializer(YYYY_MM_DD_HH_MM_SS) })
  generatedAt!: Date;
  @jsonMember fileId!: Id;

  constructor(
    name: string,
    description: string,
    generatedAt: Date,
    fileId: Id
  ) {
    this.name = name;
    this.description = description;
    this.generatedAt = generatedAt;
    this.fileId = fileId;
  }
}
